import React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import useMediaQuery from '@mui/material/useMediaQuery';

import Main from 'layouts/Main';
import Container from 'components/Container';
import { Form } from './components';
import { Typography } from '@mui/material';
import MenstrualPhothos from './MenstrualPhothos';
import DesignThinking from './DesignThinking';
import DesignThinkingPhotos from './DesignThinkingPhotos';
import Menstrual from './Menstrual';
import Workshop from './Workshop';
import SideBarSci from './SideBarSci';
import PictureTalk2023 from 'views/PictureTalk2023/PictureTalk2023';
import ScienceClubSideBar from 'views/ScienceClubSideBar/ScienceClubSideBar';
import Scienceclubsidebar2023 from './Scienceclubsidebar2023';

const ScienceClub= () => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <Main>
        <br/><Typography align='center' variant='h4' fontWeight={800}>
          Science Club </Typography>
        <Container>
       
        <Grid container spacing={4}>
          
            <Grid item xs={12} md={8}>
            <Form />
              <Workshop/>
              
            </Grid>
            <Grid item xs={12} md={4}>
           
                <Box marginBottom={4}>
                  <SideBarSci />
                </Box>

                <Box marginBottom={4}>
                  <Scienceclubsidebar2023 />
                </Box>
           
            </Grid>
          </Grid>
        </Container>
        <br/>
    
      
    </Main>
  );
};

export default ScienceClub;
